var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-card',{staticClass:"w-100 min-h-60 mobile-transparent"},[_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }